module.exports = __webpack_public_path__ + "static/media/tranzer_home.98fb58c7.png";